var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repeat-day-selector"},_vm._l((_vm.days),function(day,key){return _c('span',{staticClass:"repeat-day-selector__day",class:{'active': _vm.selected && _vm.selected.includes(key)},on:{"click":function($event){return _vm.selectDay(key)}}},[_vm._v(_vm._s(day)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }